export default __webpack_public_path__ + "static/media/tile-1-short.099c4a30.png";